import { c as _c } from "react/compiler-runtime";
import ResetPasswordView from "@repo/ui/components/auth/ResetPasswordView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { resetPasswordSearchSchema } from "@/lib/schemas/searchParams.schema";
import { decodeStatusParam } from "@/lib/utils/statusParam";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/_auth/aterstall-losenord")({
  component: ResetPasswordPage,
  validateSearch: resetPasswordSearchSchema
});
const EXPIRED_LINK_MESSAGE = {
  message: "Länken har gått ut eller redan använts. Begär en ny länk för att återställa ditt lösenord.",
  variant: "error"
};
function ResetPasswordPage() {
  const $ = _c(19);
  const navigate = useNavigate();
  const search = Route.useSearch();
  const linkExpired = !search.token || Boolean(search.error);
  let t0;
  if ($[0] !== search.meddelande) {
    t0 = decodeStatusParam(search.meddelande);
    $[0] = search.meddelande;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const decoded = t0;
  let t1;
  if ($[2] !== decoded || $[3] !== linkExpired) {
    t1 = linkExpired ? EXPIRED_LINK_MESSAGE : decoded ? {
      message: decoded,
      variant: "error"
    } : undefined;
    $[2] = decoded;
    $[3] = linkExpired;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const statusMessage = t1;
  let t2;
  let t3;
  if ($[5] !== navigate) {
    t2 = () => navigate({
      to: "/logga-in",
      search: {
        bekraftelsemeddelande: encodeURIComponent(btoa("Ditt l\xF6senord har \xE5terst\xE4llts. Du kan nu logga in med ditt nya l\xF6senord."))
      }
    });
    t3 = () => navigate({
      to: "/logga-in"
    });
    $[5] = navigate;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  const t4 = statusMessage ?? null;
  const t5 = linkExpired ? "Beg\xE4r en ny l\xE4nk" : undefined;
  let t6;
  if ($[8] !== linkExpired || $[9] !== navigate || $[10] !== search.token) {
    t6 = () => linkExpired ? navigate({
      to: "/begar-aterstall-losenord"
    }) : navigate({
      to: "/aterstall-losenord",
      search: {
        token: search.token
      }
    });
    $[8] = linkExpired;
    $[9] = navigate;
    $[10] = search.token;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== search.token || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = /*#__PURE__*/_jsx(ResetPasswordView, {
      authClient: authClient,
      token: search.token,
      onSuccess: t2,
      onBackToSignIn: t3,
      statusMessage: t4,
      statusMessageActionLabel: t5,
      onStatusMessageAction: t6
    });
    $[12] = search.token;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}